// extracted by mini-css-extract-plugin
module.exports = {"container":"imageview_container__2u7eg","label":"imageview_label__33d4y"};